import type { TFunction } from "i18next";
import useTranslation from "@hooks/use_translation";
import { differenceInCalendarDays } from "date-fns";

const timeSinceText = (timestamp: string, t: TFunction): string => {
  const datePublished = Date.parse(timestamp);

  if (isNaN(datePublished)) {
    return "";
  }

  const daysSince = differenceInCalendarDays(new Date(), datePublished);
  if (daysSince < 7) {
    return t("publishedDaysAgo", { count: daysSince });
  }

  const weeksSince = Math.floor(daysSince / 7);
  return t("publishedWeeksAgo", { count: weeksSince });
};

const useTimeSincePublishedText = (timestamp: string): string => {
  const { t } = useTranslation("jobSearch");
  return timeSinceText(timestamp, t);
};

export default useTimeSincePublishedText;
